import React from "react";
import PropTypes from "prop-types";
import styles from "./EventInfoCard.module.css";
import { v4 } from "uuid";

import InfoItem from "Security/Shared/InfoItem";
import Card from "shared/Card";
import Button from "shared/Button";

/**
 * Interactive component. Displays information about an event inside of a card.
 */
export function EventInfoCard({ event, onClick }) {
  return (
    <Card
      className={styles.card}
      children={
        <div className={styles["card-content"]}>
          <div>
            <div className={styles.header}>
              <p>{event.name}</p>
            </div>
            <div className={styles.event}>
              {[
                { label: "Event Center", description: event.city },
                { label: "City", description: event.city },
                { label: "State", description: event.state },
                { label: "Event Date", description: event.date },
              ].map((object) => (
                <InfoItem {...object} key={v4()} />
              ))}
              {!isNaN(event.complaints) && (
                <InfoItem
                  label="Complaints"
                  description={event.complaints.toString()}
                />
              )}
              {onClick && (
                <Button
                  children={<p>Details</p>}
                  type="button"
                  onClick={onClick}
                />
              )}
            </div>
          </div>
        </div>
      }
    />
  );
}

EventInfoCard.propTypes = {
  /**
   * Object with the event's details.
   * Complaints is optional.
   */
  event: PropTypes.shape({
    name: PropTypes.string,
    center: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    date: PropTypes.string,
    complaints: PropTypes.number,
  }),
  /**
   * Function called when the details button is clicked.
   * (If included, takes the user to the Event Details page).
   */
  onClick: PropTypes.func,
};
